import { useItemsListHelpers } from "@/components/ListingPages/ItemsLister/composables/itemsListHelpers/itemsListHelpers";
import itemsListerConfig from './config/itemsLister.config';

const {
  apiPathsConfig,
  filtersDisplayConfig,
  isAddAllFiltersConfig,
  columns,
  entityItemsNamePlural,
  entityItemName
} = itemsListerConfig;

export function useLiveStreamsListHelpers() {
  return useItemsListHelpers({
    apiPathsConfig,
    filtersDisplayConfig,
    isAddAllFiltersConfig,
    columns,
    entityItemsNamePlural,
    entityItemName,
    sortsConfigOverride: {
      fieldName: "DateLastModified",
      isDescending: true
    }
  })
}